import React from "react";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import PanelHeader from "components/panelheader/panelHeader";
import { FormGroup, Input, Button, Card, CardBody, CardHeader, CardTitle, Table, Row, Col } from "reactstrap";
import { getSede, saveSede } from "services/sedesService";
import { toastBigError, toastConfirm } from "components/utils/toasts";
import Joi from "joi-browser";
import { usePageLoading } from "hooks/usePageLoading";

const SedesForm = (props) => {
  const doneLoading = usePageLoading(props);
  let { id } = useParams();
  let location = useLocation();
  let navigate = useNavigate();
  //   let { state } = useLocation();
  const validateForm = true;
  const [data, setData] = React.useState({ _id: id ? id : null, nombre: "" });
  const [errors, setErrors] = React.useState([]);
  const [action, setAction] = React.useState(location.state?.action ? location.state.action : "");

  const schema = {
    _id: Joi.string(),
    nombre: Joi.string()
      .label("Nombre")
      .required()
      .error((errors) => {
        return errors.map((error) => {
          switch (error.type) {
            case "any.empty":
              return { message: "Debe ingresar un nombre" };
            default:
              return { message: "Debe ingresar un nombre" };
          }
        });
      }),
  };

  const fetchData = async (id) => {
    try {
      const record = await getSede(id);
      mapToViewModel(record);
    } finally {
      doneLoading();
    }
  };

  React.useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    const id = data._id;
    if (id && !id.includes("nuev")) {
      fetchData(id);
    } else {
      const cacheData = { ...data };
      delete cacheData._id;
      setData(cacheData);
      setAction("A");
      doneLoading();
    }
  }, []);

  const mapToViewModel = (sede) => {
    setData({
      _id: sede._id,
      nombre: sede.nombre,
    });
  };

  const handleChange = (event) => {
    const input = event.currentTarget;
    const inputMode = event.target.inputMode;
    const cacheErrors = { ...errors };
    const cacheData = { ...data };
    if (validateForm) {
      const errorMessage = validateProperty(input, inputMode);
      if (errorMessage) {
        cacheErrors[input.name] = errorMessage;
      } else delete cacheErrors[input.name];
    } else delete cacheErrors[input.name];
    cacheData[input.name] = input.value;
    if (input.type === "checkbox") cacheData[input.name] = input.checked;
    setData(cacheData);
    setErrors(cacheErrors);
  };

  const validateRules = () => {
    return null;
  };

  const validate = () => {
    let errors = {};
    const options = { abortEarly: false };
    if (validateForm) {
      //   var { data } = this.state;
      Object.keys(data).map(function (key, index) {
        if ((key.toLowerCase().includes("dni") || key.toLowerCase().includes("documento")) && !key.toLowerCase().includes("tipo")) {
          const valor = data[key];
          const stripped = valor.replaceAll(".", "");
          if (stripped.length === 8) {
            const nuevoValor = stripped.substring(0, 2) + "." + stripped.substring(2, 5) + "." + stripped.substring(5, 8);
            data[key] = nuevoValor;
          }
          if (stripped.length === 7) {
            const nuevoValor = stripped.substring(0, 1) + "." + stripped.substring(1, 4) + "." + stripped.substring(4, 7);
            data[key] = nuevoValor;
          }
        }
        if (typeof data[key] === "object" && data[key] && data[key].value && typeof data[key].value === "string") {
          data[key] = data[key].value;
        }
      });
      let { error } = Joi.validate(data, schema, options);
      if (!error) {
        error = validateRules();
        if (!error) {
          Object.keys(data).map(function (key, index) {
            if (typeof data[key] === "object" && data[key] && data[key].value) data[key] = data[key].value;
          });
          return null;
        }
        error.map((error) => {
          toastBigError(error.message, 2500);
          return (errors[error.path] = error.message);
        });
        return errors;
      } else {
        error.details.map((validationError) => {
          return (errors[validationError.path[0]] = validationError.message);
        });
        return errors;
      }
    } else return null;
  };

  const validateProperty = (input, inputMode) => {
    let { name, value } = input;
    if (inputMode === "numeric") {
      const index = value.indexOf(" ");
      value = parseFloat(value.substr(value.indexOf(" ") + 1));
    }
    const object = { [name]: value };
    const checkSchema = { [name]: schema[name] };
    const { error } = Joi.validate(object, checkSchema);
    return error ? error.details[0].message : null;
  };

  const prepareData = () => {};

  const handleSubmit = (event) => {
    if (event) event.preventDefault();
    prepareData();
    const checkErrors = validate();
    if (checkErrors) {
      setErrors(checkErrors);
      // console.log(checkErrors);
      return;
    }
    doSubmit();
  };

  const doSubmit = async () => {
    await saveSede(data);
    navigate(-1);
  };

  const goBack = () => {
    navigate(-1);
  };

  return (
    <>
      <PanelHeader size="sm" />
      <div className="content">
        <Row>
          <Col xs={12}>
            <Card>
              {/* <CardHeader>
                <CardTitle>
                  <Row className="align-items-center">
                    <Col>
                      <h4 className="pull-left" color="black">
                        <strong>Sede</strong>
                      </h4>
                    </Col>
                  </Row>
                </CardTitle>
              </CardHeader> */}
              <CardBody>
                <FormGroup className={`has-label ` + (errors["nombre"] ? "has-danger" : "")}>
                  <label>Nombre</label>
                  <Input
                    id="nombre"
                    name="nombre"
                    autoComplete="off"
                    value={data.nombre}
                    onChange={(e) => handleChange(e)}
                    // onChange={(e) => {
                    //   if (!verifyLength(e.target.value, 1)) {
                    //     setregisterPasswordState("has-danger");
                    //   } else {
                    //     setregisterPasswordState("has-success");
                    //   }
                    //   setregisterPassword(e.target.value);
                    // }
                    //}
                  />
                </FormGroup>
                <Row>
                  <Col md="12">
                    <Button className="pull-right btn-cancelar" onClick={goBack}>
                      Cancelar
                    </Button>
                    <Button className="pull-right btn-arhock" onClick={handleSubmit}>
                      Aceptar
                    </Button>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default SedesForm;
